import { Trans } from '@lingui/react/macro';

import { ArticleTaskType } from '@/api';
import { useNavigate } from '@/components/Link/Link';
import Button from '@/design_system/Button';
import { ArticleWithRelations } from '@/models/shipment';
import useViewPort from '@/utils/useViewport';

export const ArticleShipmentNextTaskCell = ({ article }: { article: ArticleWithRelations }) => {
  const { isMobile } = useViewPort();
  const navigate = useNavigate();

  const isArchivedItem = !article.requestId;

  if (isArchivedItem) {
    return null;
  }

  if (article.taskType === 'analyze_article') {
    return (
      <Button
        variant="primary"
        size="medium"
        to={`/requests/${article.requestId}/articles/${article.id}`}
        style={isMobile ? { flex: 1 } : undefined}
      >
        <Trans id="shipment.article.start-analysis">Start the analysis</Trans>
      </Button>
    );
  }

  if (article.taskType === 'create_shipment') {
    return (
      <Button
        variant="primary"
        size="medium"
        onPress={() =>
          navigate('/shipments/new', {
            state: { requestId: article.requestId, articleId: article.id },
          })
        }
        style={isMobile ? { flex: 1 } : undefined}
      >
        <Trans id="shipment.article.create-shipment">Create new shipment</Trans>
      </Button>
    );
  }

  if (article.taskType === 'validate_transit') {
    return (
      <Button
        variant="primary"
        size="medium"
        to={`/requests/${article.requestId}/articles/${article.id}`}
        style={isMobile ? { flex: 1 } : undefined}
      >
        <Trans id="shipment.article.validate-transit">Validate transit</Trans>
      </Button>
    );
  }

  if (article.taskType === 'control_quality') {
    return (
      <Button
        variant="primary"
        size="medium"
        to={`/requests/${article.requestId}/articles/${article.id}`}
        style={isMobile ? { flex: 1 } : undefined}
      >
        <Trans id="shipment.article.start-quality-control">Start quality control</Trans>
      </Button>
    );
  }

  if (article.taskType === 'adjust_service_during_processing') {
    return (
      <Button
        variant="primary"
        size="medium"
        to={`/requests/${article.requestId}/articles/${article.id}`}
        style={isMobile ? { flex: 1 } : undefined}
      >
        <Trans id="shipment.article.processing-review-services">Review services</Trans>
      </Button>
    );
  }

  return null;
};

const NEXT_TASKS: ArticleTaskType[] = [
  'analyze_article',
  'create_shipment',
  'validate_transit',
  'control_quality',
  'adjust_service_during_processing',
];

export const hasArticleShipmentNextTask = ({
  article,
}: {
  article: { workshopId: string | null; taskType: ArticleTaskType | null };
}) => {
  return !!article.taskType && NEXT_TASKS.includes(article.taskType);
};
